module.exports = __webpack_public_path__ + "static/media/tracey-max.f5a951e6.wav";